import { render, staticRenderFns } from "./HeaderUserArea.vue?vue&type=template&id=2c756178&"
import script from "./HeaderUserArea.vue?vue&type=script&lang=js&"
export * from "./HeaderUserArea.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserArea.vue?vue&type=style&index=0&id=2c756178&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports